import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';
import type { AuthUser } from '@/modules/auth/models/AuthUser';

export class AdvisorUpgradePageFaqExpanded extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ADVISOR_UPGRADE_PAGE_FAQ_EXPANDED;

  questionId: string;
  userId: number | undefined;

  constructor(questionId: string, authUser?: AuthUser) {
    super();

    this.questionId = questionId;
    this.userId = authUser?.id;
  }

  areAllPropertiesRequired(): boolean {
    return false;
  }
}
